<div class="modal-header">
  <h4 class="modal-title">{{ title | translate }}</h4>
  <button type="button" class="close" (click)="closeModal()">{{ 'circulationModal.modalHeader.closeButton' | translate }}</button>
</div>

<div class="modal-body">
  <div class="form-group">
    <label for="filmInput">{{ 'addReservationModal.form.filmLabel' | translate }}</label>
    <div class="input-group">
      <input id="filmInput"
             type="text"
             class="form-control"
             [(ngModel)]="selectedFilm"
             [ngbTypeahead]="searchFilms"
             [inputFormatter]="formatter"
             [resultFormatter]="formatter"
             placeholder="{{ 'addReservationModal.form.searchPlaceholder' | translate }}"
             (selectItem)="onFilmSelect($event)"
      />
    </div>
  </div>

  <div>
    <div class="d-flex justify-content-end show-add-circ">
      <button (click)="addCirculation()" class="btn btn-add-circ btn-add btn-bottom-margin" title="{{ 'circulationModal.form.addCirculationButton' | translate }}">
        <i class="bi bi-plus-circle"></i>
        {{'circulationModal.form.addCirculation' | translate }}
      </button>
    </div>
    <div class="row circulation-cards"  *ngIf="circulations && circulations.length > 0">
      <ng-container *ngFor="let circulation of circulations; let i = index">
        <div class="col-2 circulation-card">
          <div class="card-header">
            <ng-container [ngSwitch]="circulation.etat">
              <i *ngSwitchCase="6" class="bi bi-check-circle-fill status-icon-success"></i>
              <i *ngSwitchCase="5" class="bi bi-4-circle-fill status-icon-info"></i>
              <i *ngSwitchCase="4" class="bi bi-3-circle-fill status-icon-success"></i>
              <i *ngSwitchCase="3" class="bi bi-2-circle-fill status-icon-warning"></i>
              <i *ngSwitchCase="2" class="bi bi-1-circle-fill status-icon-info"></i>
              <i *ngSwitchCase="1" class="bi bi-ban-fill status-icon-danger"></i>
              <i *ngSwitchDefault class="bi bi-circle-fill status-icon-muted"></i>
            </ng-container>
            <h6>{{ 'circulationModal.form.tableTitle' | translate }}</h6>
            <p>({{ circulation.type }}
              <ng-container [ngSwitch]="circulation.etat">
                <span *ngSwitchCase="6">{{ 'circulationModal.statusReservation.6' | translate }}</span>
                <span *ngSwitchCase="5">{{ 'circulationModal.statusReservation.5' | translate }}</span>
                <span *ngSwitchCase="4">{{ 'circulationModal.statusReservation.4' | translate }}</span>
                <span *ngSwitchCase="3">{{ 'circulationModal.statusReservation.3' | translate }}</span>
                <span *ngSwitchCase="2">{{ 'circulationModal.statusReservation.2' | translate }}</span>
                <span *ngSwitchCase="1">{{ 'circulationModal.statusReservation.1' | translate }}</span>
                <span *ngSwitchDefault></span>
              </ng-container>)
            </p>
          </div>
          <div *ngIf="circulation.sem && Object.keys(circulation.sem).length > 0">
            <ul>
              <li *ngFor="let sem of Object.values(circulation.sem)">
                <strong>{{ sem.date_debut | date:'dd/MM/yyyy' }}</strong>
                <span *ngIf="sem.liv_ville">- {{ sem.liv_ville }}</span>
                <span *ngIf="sem.nom_cinema">- {{ sem.nom_cinema }}</span>
                <span *ngIf="sem.nb_seances || sem.nb_seances_max">({{ sem.nb_seances }} / {{ sem.nb_seances_max }})</span>
                <span *ngIf="sem.partage_de_copie && sem.partage_de_copie.length > 0">
                    <span *ngFor="let pdc of sem.partage_de_copie">
                    <span>{{ 'circulationModal.form.plus' | translate }}</span>
                    <span *ngIf="pdc.liv_ville">{{ pdc.liv_ville }}</span>
                    <span *ngIf="pdc.nom_cinema">- {{ pdc.nom_cinema }}</span>
                    <span *ngIf="pdc.nb_seances || pdc.nb_seances_max">({{ pdc.nb_seances }} / {{ pdc.nb_seances_max }})</span>
                </span>
                </span>
              </li>
            </ul>
          </div>
          <div class="section-cards">
            <button (click)="removeCirculation($event, circulation.id_circul, i)" class="btn btn-icon btn-delete"  title="{{ 'circulationModal.form.removeCirculationButton' | translate }}">
              <i class="bi bi-x-circle"></i>
            </button>
            <button (click)="editCirculation(i)" class="btn btn-icon btn-edit"  title="{{ 'circulationModal.form.editCirculationButton' | translate }}">
              <i class="bi bi-pencil-square"></i>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div id="editCirculation" *ngIf="editingCirculation" class="editing-circulation-modal">
    <form [formGroup]="circulationForm"  #filmForm="ngForm" (ngSubmit)="onSubmit()" class="editing-circulation-form">
      <div class="form-row display-group">
        <div class="input-row">
          <div class="form-group">
            <input type="checkbox"
                   id="is_adrc"
                   class="form-check-input"
                   formControlName="is_adrc" />
            <label for="is_adrc">{{ 'circulationModal.form.adrc' | translate }}</label>
          </div>
          <div class="form-group">
            <input type="checkbox"
                   id="copie_distri"
                   class="form-check-input"
                   formControlName="copie_distri" />
            <label for="copie_distri">{{ 'circulationModal.form.copie_distri' | translate }}</label>
          </div>


          <div class="form-group">
            <input
              class="form-control form-control-sm datepicker-input"
              placeholder="{{ 'circulationModal.form.date_debut' | translate }}"
              ngbDatepicker
              #d1="ngbDatepicker"
              (click)="d1.toggle()"
              id="dateDebut"
              formControlName="date_debut"
              [firstDayOfWeek]="3"
            />
          </div>

          <div class="form-group">
            <select class="form-control form-control-sm" id="etat" formControlName="etat" >
              <option value="" selected disabled>{{ 'circulationModal.form.statusLabel' | translate }}</option>
              <option *ngFor="let status of listStatus" [value]="status.id">{{ status.label }}</option>
            </select>
          </div>
        </div>
      </div>

      <ng-container *ngIf="semControls.length > 0" formArrayName="sem">
          <div  *ngFor="let control of semControls; let i = index" [formGroupName]="i">
          <div class="row mt-4">
            <input type="hidden" formControlName="id_reser" />
            <div class="col-2">
              <input class="form-control form-control-sm datepicker-input"
                     placeholder="{{ 'circulationModal.form.dateLabel' | translate }}"
                     ngbDatepicker #d2="ngbDatepicker"
                     (click)="d2.toggle()"
                     (dateSelect)="onDateChange($event)"
                     formControlName="date_debut"
                     [firstDayOfWeek]="3"/>
            </div>
            <div class="col-4">
              <select formControlName="id_reser" class="form-control form-control-sm" id="cinemaSelect">
                  <option value="" selected disabled>{{ 'circulationModal.form.cinemaLabel' | translate }}</option>
                @for (cinema of getCinemasForDate(control.value.date_debut); track cinema.id_cinema) {
                  <option [value]="cinema.id_reser">{{ cinema.liv_ville }} - {{ cinema.nom_cinema }}</option>
                }
              </select>
            </div>
            <div class="col-2">
              <input
                placeholder="{{ 'circulationModal.form.seanceLabel' | translate }}"
                type="number"
                formControlName="nb_seances"
                class="form-control form-control-sm"
                min="0">
            </div>
            <div class="col-2">
              <input
                placeholder="{{ 'circulationModal.form.maxSeanceLabel' | translate }}"
                type="number"
                formControlName="nb_seances_max"
                class="form-control form-control-sm"
                min="0">
            </div>
            <div class="button-wrapper col-2">
              <button  type="button"  (click)="removeWeek($event, i)" class="btn btn-icon btn-delete mx-2" title="{{ 'circulationModal.form.removeWeekButton' | translate }}">
                <i class="bi bi-x-circle"></i>
              </button>
              <button  type="button"  (click)="addPdc($event, i, control.value.date_debut, control.value.id_reser)" class="btn btn-icon btn-add" title="{{ 'circulationModal.form.addCopie' | translate }}">
                <i class="bi bi-plus-circle"></i>
              </button>
            </div>
          </div>
            <ng-container *ngIf="pdcControls.length > 0" formArrayName="partage_de_copie">
              <div class="row" *ngFor="let pdc of pdcControls(i); let j = index" [formGroupName]="j">
                  <div class="col-2"></div>
                  <input type="hidden" formControlName="id_reser" />
                  <div class="col-4">
                    <select formControlName="id_reser" class="form-control form-control-sm"  id="pdcCinemaSelect">
                      <option value="" selected disabled>{{ 'circulationModal.form.cinemaCopieLabel' | translate }}</option>
                      @for (cinema of getCinemasPdc(pdc.value.id_reser.toString(), control.value.id_reser); track cinema.id_reser) {
                        <option [value]="cinema.id_reser">{{ cinema.liv_ville }} - {{ cinema.nom_cinema }}</option>
                      }
                    </select>
                  </div>
                  <div class="col-2">
                    <input
                      placeholder="{{ 'circulationModal.form.seanceLabel' | translate }}"
                      type="number"
                      formControlName="nb_seances"
                      class="form-control form-control-sm"
                      min="0">
                  </div>
                  <div class="col-2">
                    <input
                      placeholder="{{ 'circulationModal.form.maxSeanceLabel' | translate }}"
                      type="number"
                      formControlName="nb_seances_max"
                      class="form-control form-control-sm"
                      min="0">
                  </div>
                  <div class="col-2">
                    <button type="button" (click)="removePdc($event, i, j)" class="btn btn-icon btn-delete mx-2" title="{{ 'circulationModal.form.removeCopieButton' | translate }}">
                      <i class="bi bi-x-circle"></i>
                    </button>
                  </div>
              </div>
            </ng-container>
          <!--</div>-->
        </div>
      </ng-container>
      <div class="section-header">
        <button  type="button"  (click)="addWeek($event)"  class="btn btn-icon btn-add mt-2" title="{{ 'circulationModal.form.addWeekButton' | translate }}">
          <i class="bi bi-plus-circle"></i>
        </button>
      </div>
    </form>
    <div class="d-flex justify-content-end">
      <button type="button"  class="btn btn-secondary mx-2" title="{{ 'circulationModal.form.cancelButton' | translate }}"
              (click)="cancelEdit()" >
        {{ 'circulationModal.form.cancelButton' | translate }}
      </button>
      <button type="button" class="btn btn-primary"
              title="{{ 'circulationModal.form.validCircButton' | translate }}"
              (click)="filmForm.ngSubmit.emit()">
        {{ 'circulationModal.form.validateButton' | translate }}
      </button>
    </div>
  </div>

</div>

